module.exports = __webpack_public_path__ + "static/media/pk_neo_pix.2d847791.jpg";